import apiFetch from '../apiFetch'

export default function (token, financingId) {
  return apiFetch({ endPoint: 'financeCompany/' + financingId, method: 'GET', token: token })
}
